import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import Auth from '../../../../Layout/Auth';

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/AddonGroup.scss';

// Lazy load components for better performance
const AddonGroupList = lazy(() => import('../Pages/AddonGroupList'));
const AddAddonGroup = lazy(() => import('../Pages/AddAddonGroup'));
const EditAddonGroup = lazy(() => import('../Pages/EditAddonGroup'));
const ViewAddonGroup = lazy(() => import('../Pages/ViewAddonGroup'));

// Loading component for Suspense fallback
const Loading = () => (
  <LoadingOverlay
    active={false}
    spinner={<FadeLoader color={"#36D7B7"} />}
    text="Loading..."
    styles={{
      overlay: (base) => ({
        ...base,
        background: "rgba(255, 255, 255, 0.8)",
      }),
      content: (base) => ({
        ...base,
        color: "#36D7B7",
      }),
    }}
  >
    <div style={{ height: "100vh" }}></div>
  </LoadingOverlay>
);

const AddonGroupRoute = ({ t }) => {
  const history = useHistory();

  return (
    <Switch>
      <Route
        exact
        path="/:lng/stock/addon-groups"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <AddonGroupList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/stock/addon-groups/list"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <AddonGroupList history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/stock/addon-groups/add"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <AddAddonGroup history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/stock/addon-groups/edit/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <EditAddonGroup history={history} />
            </Suspense>
          </Auth>
        )}
      />
      <Route
        exact
        path="/:lng/stock/addon-groups/view/:slack"
        render={() => (
          <Auth history={history} allowedRoles={['app_admin', 'admin', 'staff', 'agent']}>
            <Suspense fallback={<Loading />}>
              <ViewAddonGroup history={history} />
            </Suspense>
          </Auth>
        )}
      />
    </Switch>
  );
};

export default withNamespaces()(AddonGroupRoute);
